import React, {Component} from 'react';

export class FractionInput extends Component {
    static displayName = FractionInput.name;

    constructor(props) {
        super(props);
        this.state = {
            reportChange: props.onChange,
            numerator: "",
            denominator: ""
        };
        this.handleNumeratorChange = this.handleNumeratorChange.bind(this);
        this.handleDenominatorChange = this.handleDenominatorChange.bind(this);
    }

    handleNumeratorChange(event) {
        this.performChange({numerator: +event.target.value});
    }

    handleDenominatorChange(event) {
        this.performChange({denominator: +event.target.value});
    }

    performChange(change) {
        this.setState(change, () => {
            if (this.state.reportChange) this.state.reportChange({value: [this.state.numerator, this.state.denominator]});
        });
    }

    render() {
        return (
            <div style={{width: "80px"}}>
                <input type="number"
                       value={this.state.numerator}
                       onChange={this.handleNumeratorChange}
                       autoFocus
                       style={{width: "70%", marginLeft: "12px"}}/>
                <div style={{height: "4px", backgroundColor: "black", margin: "2px"}}/>
                <input type="number"
                       value={this.state.denominator}
                       onChange={this.handleDenominatorChange}
                       style={{width: "70%", marginLeft: "12px", marginBottom: "15px"}}/>
            </div>
        );
    }
}
